<template>
  <div>
    <NuxtLink v-if="article.image" class="" :to="article._path">
      <img :src="article.image.src" alt="Featured Article Image" class="rounded-lg mb-5" />
    </NuxtLink>
    <HeadingBasic class="leading-tight mb-3" style="text-wrap: balance" :size="1">
      <NuxtLink class="hover:!text-cardinal dark:hover:!text-cardinal-300" :to="article._path">{{
        article.title
      }}</NuxtLink>
    </HeadingBasic>
    <ArticleAuthorDate :article="article" />
    <p class="mt-3 mb-5">{{ article.description }}</p>
    <ButtonPill class="mt-5" :to="article._path"> Read Full Article </ButtonPill>
  </div>
</template>

<script lang="ts" setup>
import type { BlogPost } from '~/types/blog-post';
defineProps<{
  article: BlogPost;
}>();
</script>
